document.addEventListener('DOMContentLoaded', function () {
    const inputs = document.querySelectorAll('fieldset.variant-input-wrap .variant-input input');

    inputs.forEach(input => {
        input.addEventListener("change", function () {
            var metafieldValue = this.dataset.variantMetafield;
            let metafieldTabs = document.querySelectorAll(".product-single__meta .product-block--tab.use-variant-metafield");

            metafieldTabs.forEach(el => {
                let content = el.querySelector(".collapsible-content .collapsible-content__inner");

                if (metafieldValue && metafieldValue.trim() !== '') {
                    content.textContent = metafieldValue;
                    el.style.display = 'block';  
                } else {
                    content.textContent = '';
                    el.style.display = 'none';   
                }
            });
        });
    });
});
